import GlobalFunctions from '../global'

/**
 * Call to API to get a store's print settings
 * @function
 * @param {string} id - The store id.
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const getSettings = function (id) {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'GET',
      dataType: 'json',
      url: `/app/locationprint/${id}/show`,
      success: response => resolve(response),
      error: error => {
        if (error && error.responseJSON && error.responseJSON.payload === 'Print setting does not exist') {
          resolve({ payload: {} })
        } else {
          reject(error)
        }
      }
    })
  })
}

/**
 * Call to API to upsert print settings for a store.
 * @function
 * @param {object} data - The new printer object.
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const upsertSettings = function (data) {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'POST',
      dataType: 'json',
      url: '/app/locationprint/create',
      data: data,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

/**
 * Call to API to delete print settings
 * @function
 * @param {object} id - Id of the settings to delete
 * @returns {object} A promise that will return either a success object or an error object.
 */
export const deleteSettings = function (id) {
  return new Promise(function (resolve, reject) {
    GlobalFunctions.$ajax({
      method: 'DELETE',
      dataType: 'json',
      url: `/app/locationprint/${id}/delete`,
      success: response => resolve(response),
      error: error => reject(error)
    })
  })
}

export default {
  getSettings,
  upsertSettings,
  deleteSettings
}
